export const fmt = (n) => {
  if (!isFinite(n) || isNaN(n)) return "۰";
  return Math.round(n).toLocaleString("en-US");
};

export const formatAmountInput = (value) => {
  const digitsOnly = String(value).replace(/[^\d]/g, "");
  if (!digitsOnly) return "";
  return Number(digitsOnly).toLocaleString("en-US");
};
